module.exports = __webpack_public_path__ + "static/media/Jarmo Suomisto.cd3d64cd.jpg";